import React from 'react';

const Rhodeisland = () => {
  return (
    <div>
      
    </div>
  );
}

export default Rhodeisland;
